import { render, staticRenderFns } from "./userDashboardNutritionAllergens.vue?vue&type=template&id=cfbf5c2c"
import script from "./userDashboardNutritionAllergens.vue?vue&type=script&lang=js"
export * from "./userDashboardNutritionAllergens.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports